import { Component, Input } from '@angular/core';
import { SearchRequestService } from '../services/search-request.service';
import { IRequestHistory } from '../models/request-history.model';
import { MatTableModule } from '@angular/material/table';
import { CommonModule, DatePipe } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { StripHtmlTagsPipe } from '../../pipes/strip-html-tags.pipe';

@Component({
  selector: 'app-request-history',
  standalone: true,
  imports: [MatTableModule, CommonModule, MatProgressSpinnerModule, StripHtmlTagsPipe],
  templateUrl: './request-history.component.html',
  styleUrl: './request-history.component.scss',
  providers: [DatePipe]
})
export class RequestHistoryComponent {
  @Input({ required: true }) requestNumber!: number;
  data: IRequestHistory[] = [];
  displayedColumns: string[] = ['requestLogTime', 'requestLogEntry'];
  isLoading: boolean = false;

  constructor(private searchRequestService: SearchRequestService) { }

  loadData(): void {
    this.isLoading = true;
    this.searchRequestService.loadRequestHistoryData(this.requestNumber).subscribe(data => {
      this.isLoading = false;
      this.data = data;
    });
  }
}